// Import styles - webpack will bundle and inject these via style-loader
// widget-base.scss provides core widget styles, modal.scss adds modal-specific overrides
import './styles/widget-base.scss';
import './styles/modal.scss';


(function () {
  var DEFAULT_TARGET_ELEMENT_ID = 'ee-gift-card-widget';
  var MODAL_CONTAINER_ID = 'ee-gift-card-modal';
  var DEFAULT_TRIGGER_SELECTOR = '.ee-gc-trigger';
  var TRACKING_SURFACE = 'widget_gift_card';

  // ---------------------------------------------------------------------------
  // Public tracking + third-party pixel injection (runs on host page)
  // ---------------------------------------------------------------------------
  function getOrCreateId(storage, key) {
    try {
      var existing = storage.getItem(key);
      if (existing) return existing;
      var id = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('ee_' + Math.random().toString(36).slice(2) + Date.now().toString(36));
      storage.setItem(key, id);
      return id;
    } catch (e) {
      return ('ee_' + Math.random().toString(36).slice(2) + Date.now().toString(36));
    }
  }

  function safeSessionStorageGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSessionStorageSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) {}
  }

  function getOrCreateSessionId(tracker) {
    var policy = (tracker && tracker._eagleEyeSessionPolicy) ? tracker._eagleEyeSessionPolicy : 'TabLifetime';
    var ttlMinutesRaw = tracker ? tracker._eagleEyeSessionTtlMinutes : null;
    var ttlMinutes = (ttlMinutesRaw == null) ? null : Number(ttlMinutesRaw);
    var now = Date.now();
    var sessionIdKey = 'ee_session_id';
    var sessionMetaKey = 'ee_session_meta';

    if (policy === 'PageLoad') {
      if (!tracker._pageLoadSessionId) {
        tracker._pageLoadSessionId = (window.crypto && window.crypto.randomUUID)
          ? window.crypto.randomUUID()
          : ('ee_' + Math.random().toString(36).slice(2) + Date.now().toString(36));
      }
      safeSessionStorageSet(sessionIdKey, tracker._pageLoadSessionId);
      return tracker._pageLoadSessionId;
    }

    if (policy === 'TabLifetime') {
      var existing = safeSessionStorageGet(sessionIdKey);
      if (existing) return existing;
      return getOrCreateId(window.sessionStorage, sessionIdKey);
    }

    var ttlMs = (ttlMinutes != null && !Number.isNaN(ttlMinutes)) ? Math.max(1, ttlMinutes) * 60 * 1000 : null;
    var meta = null;
    try {
      var raw = safeSessionStorageGet(sessionMetaKey);
      meta = raw ? JSON.parse(raw) : null;
    } catch (e) { meta = null; }

    var currentId = (meta && typeof meta.id === 'string') ? meta.id : null;
    var createdUtcMs = (meta && typeof meta.createdUtcMs === 'number') ? meta.createdUtcMs : null;
    var lastSeenUtcMs = (meta && typeof meta.lastSeenUtcMs === 'number') ? meta.lastSeenUtcMs : null;
    var shouldRotate = ttlMs != null && (
      (policy === 'IdleTimeoutMinutes' && lastSeenUtcMs != null && (now - lastSeenUtcMs) > ttlMs) ||
      (policy === 'AbsoluteTimeoutMinutes' && createdUtcMs != null && (now - createdUtcMs) > ttlMs)
    );

    var nextId = (!currentId || shouldRotate)
      ? ((window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('ee_' + Math.random().toString(36).slice(2) + Date.now().toString(36)))
      : currentId;
    var nextMeta = {
      id: nextId,
      createdUtcMs: (!currentId || shouldRotate) ? now : (createdUtcMs || now),
      lastSeenUtcMs: now
    };
    try { safeSessionStorageSet(sessionMetaKey, JSON.stringify(nextMeta)); } catch (e) {}
    return nextId;
  }

  function ensureScriptOnce(id, src) {
    return new Promise(function(resolve) {
      if (document.getElementById(id)) return resolve();
      var s = document.createElement('script');
      s.id = id;
      s.async = true;
      s.src = src;
      s.onload = function() { resolve(); };
      s.onerror = function() { resolve(); };
      document.head.appendChild(s);
    });
  }

  function normalizeProviderName(p) { return (p || '').toString(); }

  function resolveMapping(mappings, provider, internalEvent) {
    var list = mappings || [];
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (normalizeProviderName(m.provider) === provider && (m.internalEvent || '').trim() === (internalEvent || '').trim()) {
        return m;
      }
    }
    return null;
  }

  function defaultMetaEvent(internalEvent) {
    var e = (internalEvent || '').toLowerCase();
    if (e === 'page_view') return 'PageView';
    if (e === 'begin_checkout') return 'InitiateCheckout';
    if (e === 'add_payment_info') return 'AddPaymentInfo';
    if (e === 'purchase') return 'Purchase';
    return 'CustomEvent';
  }

  function defaultTikTokEvent(internalEvent) {
    var e = (internalEvent || '').toLowerCase();
    if (e === 'page_view') return 'PageView';
    if (e === 'begin_checkout') return 'InitiateCheckout';
    if (e === 'add_payment_info') return 'AddPaymentInfo';
    if (e === 'purchase') return 'CompletePayment';
    return 'Custom';
  }

  function ensureMetaPixelBootstrap() {
    if (window.fbq) return;
    (function(f,b,e,v,n,t,s){
      if (f.fbq) return;
      n = f.fbq = function(){ n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e); t.async = true; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  }

  function ensureTikTokPixelBootstrap() {
    if (window.ttq) return;
    (function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie'];
      ttq.setAndDefer = function(target, method) { target[method] = function() { target.push([method].concat([].slice.call(arguments, 0))); }; };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function(id) {
        var inst = ttq._i[id] = [];
        for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(inst, ttq.methods[i]);
        return inst;
      };
      ttq.load = function(id) {
        var s = d.createElement('script');
        s.type = 'text/javascript'; s.async = true;
        s.src = 'https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=' + id + '&lib=' + t;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      ttq._i = {}; ttq._o = {}; ttq._partner = '';
    })(window, document, 'ttq');
  }

  function ensureGtagBootstrap() {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === 'function') return;
    window.gtag = function() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
  }

  function initGiftCardTracking(baseUrl, venueId) {
    if (window.eeGiftCardTracking && window.eeGiftCardTracking._venueId === venueId) return window.eeGiftCardTracking._readyPromise || Promise.resolve();

    var tracker = window.eeGiftCardTracking || {};
    tracker._venueId = venueId;
    tracker._baseUrl = baseUrl;
    tracker._mappings = [];
    tracker._providers = [];
    tracker._eagleEyeEnabled = false;
    tracker._readyPromise = fetch(baseUrl + '/pixel-settings?venueId=' + encodeURIComponent(venueId))
      .then(function(r) { return r.json(); })
      .then(function(cfg) {
        tracker._providers = (cfg && cfg.providers) ? cfg.providers : [];
        tracker._mappings = (cfg && cfg.eventMappings) ? cfg.eventMappings : [];
        tracker._eagleEyeEnabled = !!(cfg && cfg.eagleEyeEnabled);
        tracker._eagleEyeSessionPolicy = (cfg && cfg.eagleEyeSessionPolicy) ? cfg.eagleEyeSessionPolicy : 'TabLifetime';
        tracker._eagleEyeSessionTtlMinutes = (cfg && cfg.eagleEyeSessionTtlMinutes != null) ? cfg.eagleEyeSessionTtlMinutes : null;

        // Inject common pixels on host page
        var providers = tracker._providers;
        var hasGA = providers.some(function(p) { return normalizeProviderName(p.provider) === 'GA4' || normalizeProviderName(p.provider) === 'GoogleAds'; });
        if (hasGA) {
          var firstId = (providers.find(function(p) { return normalizeProviderName(p.provider) === 'GA4'; }) || providers[0]).clientId;
          if (firstId) {
            return ensureScriptOnce('ee-gc-gtag', 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(firstId))
              .then(function() {
                ensureGtagBootstrap();
                providers.forEach(function(p) {
                  if (normalizeProviderName(p.provider) === 'GA4' || normalizeProviderName(p.provider) === 'GoogleAds') {
                    if (p.clientId) window.gtag('config', p.clientId);
                  }
                });
              });
          }
        }
      })
      .catch(function() { /* ignore */ });

    tracker.track = function(eventName, payload) {
      try {
        var skipThirdParty = !!(payload && payload.skipThirdParty === true);
        var visitorId = getOrCreateId(window.localStorage, 'ee_visitor_id');
        var sessionId = getOrCreateSessionId(tracker);
        var eventId = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('ee_' + Math.random().toString(36).slice(2));
        var sourceId = (payload && payload.sourceId) ? payload.sourceId : venueId;
        var sourceIdType = (payload && payload.sourceIdType) ? payload.sourceIdType : ((payload && payload.sourceId) ? 'Other' : 'VenueId');
        var body = {
          corporationDetailId: venueId,
          eventName: eventName,
          surface: TRACKING_SURFACE,
          visitorId: visitorId,
          sessionId: sessionId,
          eventId: eventId,
          url: window.location.href,
          referrer: document.referrer || null,
          // Sent from the browser so the visitor's device survives the widget server hop,
          // which strips it otherwise (EAG-1202).
          userAgent: (navigator && navigator.userAgent) || null,
          value: payload && payload.valueCents != null ? payload.valueCents : null,
          currency: payload && payload.currency ? payload.currency : null,
          sourceId: sourceId,
          sourceIdType: sourceIdType,
          secondarySourceId: venueId,
          secondarySourceIdType: 'VenueId',
          email: payload && payload.email ? payload.email : null,
          phoneNumber: payload && payload.phoneNumber ? payload.phoneNumber : null,
          properties: payload && payload.properties ? payload.properties : null
        };

        if (tracker._eagleEyeEnabled === true) {
          fetch(baseUrl + '/tracking/event', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Widget-Origin': window.location.origin },
            body: JSON.stringify(body),
            keepalive: true
          }).catch(function() {});
        }

        if (skipThirdParty) {
          return;
        }

        // Fire Meta/TikTok when available
        var mappings = tracker._mappings || [];
        var meta = tracker._providers.find(function(p) { return normalizeProviderName(p.provider) === 'Meta' && p.clientId; });
        if (meta && meta.clientId) {
          ensureMetaPixelBootstrap();
          window.fbq('init', meta.clientId);
          var metaMapping = resolveMapping(mappings, 'Meta', eventName);
          var metaEvent = (metaMapping && metaMapping.providerEventName) ? metaMapping.providerEventName : defaultMetaEvent(eventName);
          var params = {};
          if (payload && payload.valueCents != null) params.value = payload.valueCents / 100;
          if (payload && payload.currency) params.currency = payload.currency;
          window.fbq('track', metaEvent, params, { eventID: eventId });
        }

        var tiktok = tracker._providers.find(function(p) { return normalizeProviderName(p.provider) === 'TikTok' && p.clientId; });
        if (tiktok && tiktok.clientId) {
          ensureTikTokPixelBootstrap();
          window.ttq.load(tiktok.clientId);
          var tkMapping = resolveMapping(mappings, 'TikTok', eventName);
          var tkEvent = (tkMapping && tkMapping.providerEventName) ? tkMapping.providerEventName : defaultTikTokEvent(eventName);
          var tkParams = {};
          if (payload && payload.valueCents != null) tkParams.value = payload.valueCents / 100;
          if (payload && payload.currency) tkParams.currency = payload.currency;
          window.ttq.track(tkEvent, tkParams);
        }

        // Google (GA4 + Google Ads)
        var ga4p = tracker._providers.find(function(p) { return normalizeProviderName(p.provider) === 'GA4' && p.clientId; });
        var adsp = tracker._providers.find(function(p) { return normalizeProviderName(p.provider) === 'GoogleAds' && p.clientId; });
        if ((ga4p && ga4p.clientId) || (adsp && adsp.clientId)) {
          ensureGtagBootstrap();
          var gParams = {};
          if (payload && payload.valueCents != null) gParams.value = payload.valueCents / 100;
          if (payload && payload.currency) gParams.currency = payload.currency;

          if (ga4p && ga4p.clientId) {
            var g = resolveMapping(mappings, 'GA4', eventName);
            var ga4Event = (g && g.providerEventName) ? g.providerEventName.trim() || eventName : eventName;
            window.gtag('event', ga4Event, Object.assign({ send_to: ga4p.clientId }, gParams));
          }

          if (adsp && adsp.clientId) {
            var a = resolveMapping(mappings, 'GoogleAds', eventName);
            var label = (a && a.providerConversionId) ? a.providerConversionId.trim() : '';
            if (label) {
              var sendTo = label.indexOf('/') >= 0 ? label : (adsp.clientId + '/' + label);
              var txnId = (sourceId && sourceIdType !== 'VenueId') ? sourceId : eventId;
              window.gtag('event', 'conversion', Object.assign({ send_to: sendTo, transaction_id: txnId }, gParams));
            }
          }
        }
      } catch (e) { /* ignore */ }
    };

    // Out-of-the-box (OOB) analytics helpers (EagleEye-only by default)
    tracker._oob = tracker._oob || {
      widget: 'gift_card',
      mode: 'unknown',
      widgetLoadMs: Date.now(),
      stepViewMs: Date.now(),
      step: null,
      stepIndex: null,
      formStarted: false,
      once: {}
    };

    tracker._oobSetMode = function(mode) {
      try { tracker._oob.mode = mode || 'unknown'; } catch (e) { /* ignore */ }
    };

    tracker._oobTrack = function(eventName, props) {
      try {
        var now = Date.now();
        var baseProps = {
          widget: tracker._oob.widget,
          mode: tracker._oob.mode,
          step: tracker._oob.step,
          stepIndex: tracker._oob.stepIndex,
          timeSinceWidgetLoadMs: now - tracker._oob.widgetLoadMs,
          timeSinceStepViewMs: now - tracker._oob.stepViewMs
        };
        tracker.track(eventName, { skipThirdParty: true, properties: Object.assign({}, props || {}, baseProps) });
      } catch (e) { /* ignore */ }
    };

    tracker._oobImpressionOnce = function(componentKey) {
      try {
        var key = 'impression:' + tracker._oob.widget + ':' + tracker._oob.mode + ':' + (tracker._oob.step || 'unknown') + ':' + componentKey;
        if (tracker._oob.once[key]) return;
        tracker._oob.once[key] = true;
        tracker._oobTrack('impression', { componentKey: componentKey });
      } catch (e) { /* ignore */ }
    };

    tracker._oobSetStep = function(step, stepIndex) {
      try {
        var changed = tracker._oob.step !== step || tracker._oob.stepIndex !== stepIndex;
        tracker._oob.step = step;
        tracker._oob.stepIndex = stepIndex;
        tracker._oob.stepViewMs = Date.now();
        if (changed) {
          tracker._oobTrack('screen_view', {});
          tracker._oobTrack('form_step_view', {});
        }
      } catch (e) { /* ignore */ }
    };

    tracker._oobFormStart = function() {
      try {
        if (tracker._oob.formStarted) return;
        tracker._oob.formStarted = true;
        tracker._oobTrack('form_start', {});
      } catch (e) { /* ignore */ }
    };

    tracker._oobValidationError = function(field, rule) { tracker._oobTrack('validation_error', { field: field, rule: rule }); };
    tracker._oobApiError = function(endpointGroup, statusCode) { tracker._oobTrack('api_error', { endpointGroup: endpointGroup, statusCode: statusCode }); };
    tracker._oobPaymentError = function(provider, errorCode) { tracker._oobTrack('payment_error', { provider: provider, errorCode: errorCode }); };
    tracker._oobAbandon = function(reason) { tracker._oobTrack('abandon', { reason: reason }); };

    window.eeGiftCardTracking = tracker;
    return tracker._readyPromise || Promise.resolve();
  }

  /**
   * Default configuration for the gift card widget.
   * mode: 'embedded' renders inline at target element; 'modal' shows in overlay dialog
   * triggerSelector: CSS selector(s) for elements that open the modal (modal mode only)
   * targetElementId: DOM element ID where widget renders (embedded mode)
   */
  var DEFAULT_CONFIG = {
    mode: 'embedded',
    triggerSelector: DEFAULT_TRIGGER_SELECTOR,
    targetElementId: DEFAULT_TARGET_ELEMENT_ID
  };

  /**
   * Merge user config with defaults, ensuring backward compatibility.
   */
  function mergeConfig(userConfig) {
    var config = {};
    for (var key in DEFAULT_CONFIG) {
      config[key] = DEFAULT_CONFIG[key];
    }
    if (userConfig && typeof userConfig === 'object') {
      for (var key in userConfig) {
        if (userConfig[key] !== undefined) {
          config[key] = userConfig[key];
        }
      }
    }
    return config;
  }

  /**
   * Create modal DOM structure with 2-column layout.
   */
  function createModalContainer() {
    if (document.getElementById(MODAL_CONTAINER_ID)) {
      return document.getElementById(MODAL_CONTAINER_ID);
    }

    // Backdrop
    var backdrop = document.createElement('div');
    backdrop.className = 'ee-gc-modal-backdrop';
    backdrop.id = MODAL_CONTAINER_ID + '-backdrop';

    // Dialog
    var dialog = document.createElement('div');
    dialog.className = 'ee-gc-modal-dialog';
    dialog.id = MODAL_CONTAINER_ID;
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'ee-gc-modal-title');

    // Close button
    var closeBtn = document.createElement('button');
    closeBtn.className = 'ee-gc-modal-close';
    closeBtn.setAttribute('aria-label', 'Close gift card modal');
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M18 6L6 18M6 6l12 12"/></svg>';

    // 2-column layout container
    var layout = document.createElement('div');
    layout.className = 'ee-gc-modal-layout';

    // Left promo panel (text will be updated from widget header after load)
    var promo = document.createElement('div');
    promo.className = 'ee-gc-modal-promo';
    promo.innerHTML = `
      <div class="ee-gc-modal-promo-icon">
        <svg viewBox="0 0 24 24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
          <line x1="1" y1="10" x2="23" y2="10"></line>
        </svg>
      </div>
      <h2 id="ee-gc-modal-title" class="ee-gc-modal-promo-title">Purchase a Gift Card</h2>
      <p id="ee-gc-modal-subtitle" class="ee-gc-modal-promo-subtitle">Give the gift of a great experience!</p>
    `;

    // Right content container (widget goes here)
    var content = document.createElement('div');
    content.className = 'ee-gc-modal-content';
    content.id = DEFAULT_TARGET_ELEMENT_ID;

    layout.appendChild(promo);
    layout.appendChild(content);
    dialog.appendChild(closeBtn);
    dialog.appendChild(layout);
    document.body.appendChild(backdrop);
    document.body.appendChild(dialog);

    return dialog;
  }

  /**
   * Update modal promo panel text from widget header after widget loads.
   */
  function updateModalPromoFromWidget() {
    var widgetTitle = document.getElementById('gc-title');
    var widgetSubtitle = document.getElementById('gc-subtitle');
    var modalTitle = document.getElementById('ee-gc-modal-title');
    var modalSubtitle = document.getElementById('ee-gc-modal-subtitle');

    if (widgetTitle && modalTitle) {
      modalTitle.textContent = widgetTitle.textContent;
    }
    if (widgetSubtitle && modalSubtitle) {
      modalSubtitle.textContent = widgetSubtitle.textContent;
    }
  }

  /**
   * Open the modal dialog and optionally pre-select an amount.
   * @param {number|null} preselectedAmountDollars - Amount in dollars to pre-select, or null for no pre-selection
   */
  function openModal(preselectedAmountDollars) {
    var backdrop = document.getElementById(MODAL_CONTAINER_ID + '-backdrop');
    var dialog = document.getElementById(MODAL_CONTAINER_ID);
    if (backdrop && dialog) {
      backdrop.classList.add('ee-gc-modal-open');
      dialog.classList.add('ee-gc-modal-open');
      document.body.classList.add('ee-gc-modal-no-scroll');
      // Focus the dialog for accessibility
      dialog.focus();

      try {
        if (window.eeGiftCardTracking && typeof window.eeGiftCardTracking.track === 'function') {
          window.eeGiftCardTracking.track('begin_checkout', { properties: { mode: 'modal', preselectedAmountDollars: preselectedAmountDollars } });
        }
      } catch (e) { /* ignore */ }

      // Pre-select amount if specified
      if (preselectedAmountDollars !== null && preselectedAmountDollars !== undefined) {
        var amountCents = preselectedAmountDollars * 100;
        var amountSelect = document.getElementById('gc-amount');
        if (amountSelect) {
          // Always set the value (even if options are still loading); when the matching option
          // is later appended, the browser will auto-select it.
          amountSelect.value = amountCents.toString();

          // Programmatic value assignment does NOT fire "change", but widget UI binds off it.
          try { amountSelect.dispatchEvent(new Event('change', { bubbles: true })); } catch (_) { /* ignore */ }

          // Re-dispatch shortly after to ensure re-bind once async options finish loading.
          setTimeout(function () {
            try {
              if (amountSelect && amountSelect.value === amountCents.toString()) {
                amountSelect.dispatchEvent(new Event('change', { bubbles: true }));
              }
            } catch (_) { /* ignore */ }
          }, 350);
        }
      }
    }
  }

  /**
   * Close the modal dialog.
   */
  function closeModal() {
    var backdrop = document.getElementById(MODAL_CONTAINER_ID + '-backdrop');
    var dialog = document.getElementById(MODAL_CONTAINER_ID);
    if (backdrop && dialog) {
      backdrop.classList.remove('ee-gc-modal-open');
      dialog.classList.remove('ee-gc-modal-open');
      document.body.classList.remove('ee-gc-modal-no-scroll');
    }
  }

  /**
   * Attach modal event handlers (escape key, close button).
   * Note: Backdrop click does NOT close the modal to prevent accidental dismissal during form entry.
   */
  function attachModalHandlers() {
    var dialog = document.getElementById(MODAL_CONTAINER_ID);
    var closeBtn = dialog ? dialog.querySelector('.ee-gc-modal-close') : null;

    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var dialogEl = document.getElementById(MODAL_CONTAINER_ID);
        if (dialogEl && dialogEl.classList.contains('ee-gc-modal-open')) {
          closeModal();
        }
      }
    });
  }

  /**
   * Attach click handlers to trigger elements.
   * Reads data-ee-gc-amount attribute to pre-select amount when modal opens.
   */
  function attachTriggers(triggerSelector) {
    if (!triggerSelector) return;

    var selectors = Array.isArray(triggerSelector) ? triggerSelector : [triggerSelector];

    selectors.forEach(function (selector) {
      var elements = document.querySelectorAll(selector);
      elements.forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          // Check for data-ee-gc-amount attribute (value in dollars)
          var amountAttr = el.getAttribute('data-ee-gc-amount');
          var preselectedAmount = amountAttr ? parseInt(amountAttr, 10) : null;
          openModal(preselectedAmount);
        });
      });
    });
  }

  /**
   * Load widget HTML content into target element.
   */
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function loadWidgetContent(venueId, targetElement, onComplete) {
    var baseUrl = EAGLEEYE_GIFTCARD_WIDGET_BASE_URL;

    console.log('DEBUG: Loading gift card widget for venueId:', venueId);
    console.log('DEBUG: Fetching from URL:', baseUrl + '/widget?venueId=' + venueId + '&provider=stripe');

    targetElement.classList.add('loading');
    targetElement.innerHTML = '<div class="gc-loading">\u2022\u2022\u2022</div>';

    var loadingTimeout = setTimeout(function () {
      targetElement.classList.remove('loading');
    }, 10000);

    fetch(baseUrl + '/widget?venueId=' + venueId + '&provider=stripe')
      .then(function (response) {
        console.log('DEBUG: Widget fetch response status:', response.status);
        if (!response.ok) {
          return response.text().then(function (errorText) {
            // Log technical details to console for debugging
            console.error('Widget load failed:', response.status, errorText);
            // Bubble up status + body so we can surface server-provided error UI (with error code)
            var err = new Error('WIDGET_LOAD_FAILED');
            err.status = response.status;
            err.body = errorText;
            err.url = response.url;
            throw err;
          });
        }
        return response.text();
      })
      .then(function (htmlContent) {
        console.log('DEBUG: Widget HTML content length:', htmlContent.length);
        console.log('DEBUG: Widget HTML preview:', htmlContent.substring(0, 500));

        clearTimeout(loadingTimeout);
        targetElement.classList.remove('loading');
        targetElement.innerHTML = '';

        var container = document.createElement('div');
        container.innerHTML = htmlContent;

        var scripts = container.querySelectorAll('script');
        console.log('DEBUG: Found', scripts.length, 'scripts in widget HTML');

        // Extract and save script info before removing them from DOM
        var scriptData = [];
        scripts.forEach(function (script, index) {
          scriptData.push({
            index: index,
            src: script.src || null,
            textContent: script.textContent || '',
            type: script.type || null
          });
          script.parentNode.removeChild(script);
        });

        // Append widget content to target element FIRST (so DOM elements exist)
        while (container.firstChild) {
          targetElement.appendChild(container.firstChild);
        }

        // NOW execute scripts after DOM is in place
        scriptData.forEach(function (data) {
          if (data.src) {
            console.log('DEBUG: Loading external script', data.index, ':', data.src);
            var newScript = document.createElement('script');
            newScript.src = data.src;
            document.head.appendChild(newScript);
          } else if (data.textContent && data.type !== 'application/json') {
            console.log('DEBUG: Executing inline script', data.index, '- length:', data.textContent.length);
            try {
              // Create a new script element instead of using eval() to ensure proper execution context
              var newScript = document.createElement('script');
              newScript.textContent = data.textContent;
              if (data.type) {
                newScript.type = data.type;
              }
              document.head.appendChild(newScript);
            } catch (e) {
              console.error('Error executing script', data.index, ':', e);
            }
          }
        });

        var mainScript = document.createElement('script');
        mainScript.src = baseUrl + '/public/js/main.bundle.js';
        mainScript.onload = function () {
          if (window.initializeGiftCardWidget) {
            window.initializeGiftCardWidget();
          }
          if (onComplete) onComplete();
        };
        document.head.appendChild(mainScript);
      })
      .catch(function (error) {
        console.error('Error loading gift card widget:', error);
        clearTimeout(loadingTimeout);
        targetElement.classList.remove('loading');

        // Prefer server-provided HTML error fragment (it includes a short error code for bug reports).
        if (error && error.body) {
          targetElement.innerHTML = error.body;
          return;
        }

        // No server response available - the fetch itself failed (network error, DNS, CORS, etc.)
        var status = (error && error.status) ? String(error.status) : '';
        var code = status ? ('WB' + status) : 'WBNET';
        var nativeMessage = (error && error.message) ? error.message : '';
        var nativeMessageSafe = escapeHtml(nativeMessage);
        var detail = 'We\'re having trouble loading gift cards right now.';
        if (!status && nativeMessage) {
          // Browser fetch() failures (e.g. "Failed to fetch", "NetworkError when attempting to fetch resource")
          detail = 'Could not connect to the gift card server. Please check your internet connection or try again later.';
        }
        targetElement.innerHTML =
          '<div class="gc-error" style="padding: 1.5rem; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; color: #991b1b; text-align: center;">' +
            '<strong style="display: block; margin-bottom: 0.5rem; font-size: 1.125rem;">Unable to Load Gift Cards</strong>' +
            '<span style="font-size: 0.9375rem; color: #b91c1c; display: block;">' + detail + '</span>' +
            (nativeMessageSafe ? '<span style="margin-top: 0.25rem; font-size: 0.8125rem; color: #9a3412; display: block;">' + nativeMessageSafe + '</span>' : '') +
            '<span style="margin-top: 0.5rem; font-size: 0.875rem; color: #7f1d1d; display: block;">Error ' + code + '</span>' +
          '</div>';
      });
  }

  /**
   * Internal initialization logic after DOM is ready.
   */
  function initWidget(venueId, cfg) {
    if (window.eagleEyeGiftCardWidgetInitialized === true) {
      console.error('Gift Card widget already initialized. Inject only once.');
      return;
    }

    try {
      initGiftCardTracking(EAGLEEYE_GIFTCARD_WIDGET_BASE_URL, venueId)
        .then(function() {
          if (window.eeGiftCardTracking && typeof window.eeGiftCardTracking.track === 'function') {
            try {
              window.eeGiftCardTracking._oobSetMode && window.eeGiftCardTracking._oobSetMode(cfg.mode);
              window.eeGiftCardTracking._oobTrack && window.eeGiftCardTracking._oobTrack('widget_loaded', { venueId: venueId });
            } catch (e) { /* ignore */ }
            window.eeGiftCardTracking.track('page_view', { sourceId: venueId, properties: { mode: cfg.mode } });
          }
        });
    } catch (e) { /* ignore */ }

    if (cfg.mode === 'modal') {
      // Modal mode: create modal container, attach triggers, load content
      var dialog = createModalContainer();
      var contentEl = dialog.querySelector('.ee-gc-modal-content');

      attachModalHandlers();
      attachTriggers(cfg.triggerSelector);

      // Pre-load widget content into modal (hidden)
      loadWidgetContent(venueId, contentEl, function () {
        // Sync promo panel text with widget header (uses custom venue wording)
        updateModalPromoFromWidget();
        // Hide the widget header in modal mode (promo panel shows it instead)
        var widgetHeader = document.getElementById('gc-header');
        if (widgetHeader) {
          widgetHeader.style.display = 'none';
        }
        console.log('DEBUG: Gift card modal widget loaded and ready');
      });
    } else {
      // Embedded mode: original behavior
      var targetElement = document.getElementById(cfg.targetElementId);
      if (!targetElement) {
        console.error('Gift Card widget target element not found. Please add <div id="' + cfg.targetElementId + '"></div> to your page.');
        return;
      }

      loadWidgetContent(venueId, targetElement);
    }

    window.eagleEyeGiftCardWidgetInitialized = true;
  }

  /**
   * Main entry point: Load the gift card widget.
   * Automatically waits for DOM ready before initializing.
   * @param {string} venueId - Corporation detail ID
   * @param {Object} [config] - Optional configuration object
   * @param {string} [config.mode='embedded'] - 'embedded' or 'modal'
   * @param {string|string[]} [config.triggerSelector] - CSS selector(s) for modal triggers
   * @param {string} [config.targetElementId='ee-gift-card-widget'] - Target element ID for embedded mode
   */
  function loadGiftCardWidget(venueId, config) {
    var cfg = mergeConfig(config);

    // Wait for DOM ready before initializing
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initWidget(venueId, cfg);
      });
    } else {
      // DOM already ready
      initWidget(venueId, cfg);
    }
  }

  /**
   * Programmatically open the gift card modal (for external use).
   * @param {number} [amountDollars] - Optional amount in dollars to pre-select
   */
  function openGiftCardModal(amountDollars) {
    openModal(amountDollars || null);
  }

  /**
   * Programmatically close the gift card modal (for external use).
   */
  function closeGiftCardModal() {
    closeModal();
  }

  // Expose public API
  window.loadGiftCardWidget = loadGiftCardWidget;
  window.openGiftCardModal = openGiftCardModal;
  window.closeGiftCardModal = closeGiftCardModal;
})();
